import { z } from 'zod';
import { DEFAULT_PAGE_SIZE, MAX_PAGE_SIZE } from '../constants.js';
/**
 * Pagination par curseur (PRD FR-22). Le décalage numérique est écarté volontairement :
 * sur une bibliothèque où de nouvelles vidéos arrivent en continu, il produit des doublons
 * et des éléments manquants entre deux pages.
 */
export const cursorPaginationSchema = z.object({
    cursor: z.string().cuid2().optional(),
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_SIZE).default(DEFAULT_PAGE_SIZE),
});
export const sortOrderSchema = z.enum(['asc', 'desc']).default('desc');
//# sourceMappingURL=pagination.js.map